import {CriterionRoute} from "@/router/Evaluation/CriterionRoute";

export const EvaluationTrainingHotFile = {
    path: '/evaluation_training_hot_files',
    name: 'evaluation_training_hot_files',
    component: () => import('@/views/Evaluation/File/EvaluationTrainingHotFilePage.vue'),
    children: [
        {
            path: '/evaluation_training_hot_files/add',
            name: 'evaluation_training_hot_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            },
            children: [
                ...CriterionRoute('evaluation_training_hot_files.add',
                    'EVALUATION_TRAINING_HOT_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_HOT')
            ]
        },
        {
            path: '/evaluation_training_hot_files/edit/:id',
            name: 'evaluation_training_hot_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            },
            children: [
                ...CriterionRoute('evaluation_training_hot_files.edit',
                    'EVALUATION_TRAINING_HOT_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_HOT')
            ]
        },
        {
            path: '/evaluation_training_hot_files/duplicate/:id',
            name: 'evaluation_training_hot_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            },
            children: [
                ...CriterionRoute('evaluation_training_hot_files.duplicate',
                    'EVALUATION_TRAINING_HOT_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_HOT')
            ]
        },
        {
            path: '/evaluation_training_hot_files/bulk_update',
            name: 'evaluation_training_hot_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            },
            children: [
                ...CriterionRoute('evaluation_training_hot_files.bulk_update',
                    'EVALUATION_TRAINING_HOT_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_HOT')
            ]
        },
        {
            path: '/evaluation_training_hot_files/delete/:id',
            name: 'evaluation_training_hot_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_files/view/:id',
            name: 'evaluation_training_hot_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_files/archive/:id',
            name: 'evaluation_training_hot_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                archiveAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_files/unarchive/:id',
            name: 'evaluation_training_hot_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
    ]
}